import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import { HardwareCriticalIotsListCard } from '../../../statistics/hardware/hardware-critical-iots-list-card/hardware-critical-iots-list-card.component';
import { HardwareIotsVolumeByStatusDonutChart } from '../../../statistics/hardware/hardware-iots-volume-by-status-donut-chart/hardware-iots-volume-by-status-donut-chart.component';
import { HardwareIotsVolumeByTypeListChart } from '../../../statistics/hardware/hardware-iots-volume-by-type-list-chart/hardware-iots-volume-by-type-list-chart.component';
import { Last7DaysHardwareIotsUptimeMetricChart } from '../../../statistics/hardware/last-7-days-hardware-iots-uptime-metric-chart/last-7-days-hardware-iots-uptime-metric-chart.component';
import { Dashboard, DashboardCard } from '../../../statistics/shared';
import OverviewHeader from '../../header/overview-header';

const HardwareDashboard = () => {
    const { currentAccount } = useAccountRepository();

    return (
        <div
            key='hardware-dashboard'
            className='bg-background-default flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='hardware-dashboard.title'
                        description='Page title of the Hardware application dashboard'
                        defaultMessage='Hardware / Dashboard'
                    />
                }
            />
            <Dashboard>
                <DashboardCard size='3x2'>
                    <HardwareCriticalIotsListCard accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x2'>
                    <HardwareIotsVolumeByStatusDonutChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x2'>
                    <HardwareIotsVolumeByTypeListChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x1'>
                    <Last7DaysHardwareIotsUptimeMetricChart accountId={currentAccount} />
                </DashboardCard>
            </Dashboard>
        </div>
    );
};

export default HardwareDashboard;
